<template>
  <div>
    <v-breadcrumbs v-if="counter_model" :items="breadcrumbsItems">
      <template v-slot:item="{ item }">
        <v-breadcrumbs-item
            href="#"
            :disabled="item.disabled"
            @click="openBreadcrumbsUrl(item)"
        >
          {{ item.text }}
        </v-breadcrumbs-item>
      </template>
    </v-breadcrumbs>
    <v-data-table
      :headers="headers"
      :items="items"
      :loading="loading"
      fixed-header
      group-by="parameter_group"
      no-data-text="Нет параметров для отображения"
      hide-default-footer
      disable-pagination
      dense
    >
      <template v-slot:item="{ item }">
        <tr>
          <td>{{ item.parameter_name }}</td>
        </tr>
      </template>
      <template v-slot:group.header="{ group }">
        <tr>
          <td><h2>
            <h3 v-if="group">{{ group }}</h3>
            <h3 v-else>Параметры без группы</h3>
          </h2>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: 'CountersModelsParameters',
  data () {
    return {
      items: [],
      loading: true,
      counter_model: null,
      headers: [
        {
          text: 'API параметр счетчика',
          align: 'left',
          value: 'parameter_name'
        }
      ],
      breadcrumbsItems: [
        {
          text: 'Ресурс',
          disabled: false,
          href: 'counters_resource'
        }
      ]
    }
  },
  mounted () {
    this.counter_model = this.$route.query.counter_model
    this.getItemsApi()
    this.fillBreadcrumb()
  },
  methods: {
    getItemsApi () {
      if (!this.counter_model) {
        this.loading = false
        return
      }
      this.loading = true
      this.axios.get(`/api/counters_models_parameters/?page_size=500&model_id=${this.counter_model}`)
        .then((response) => {
          this.items = response.data.results
          this.loading = false
        })
        .catch((err) => {
          this.loading = false
          console.log(err)
        })
    },
    fillBreadcrumb () {
      if (!this.counter_model) {
        return
      }
      this.axios.get(`api/counters_models/${this.counter_model}/`)
        .then((response) => {
          var model = response.data
          this.axios.get(`api/resources_types/${model.resource_type.resource_type_id}/`)
            .then((response) => {
              this.breadcrumbsItems.push(
                {
                  text: response.data.name,
                  disabled: false,
                  href: 'counters_models_api?resource_type=' + model.resource_type.resource_type_id
                }
              )
              this.axios.get(`api/counters_api/${model.counter_model_api}/`)
                .then((modelApiResponse) => {
                  this.breadcrumbsItems.push(
                    {
                      text: modelApiResponse.data.name,
                      disabled: false,
                      href: 'counters_models?resource_type=' + model.resource_type.resource_type_id + '&counter_model_api=' + model.counter_model_api
                    }
                  )
                  this.breadcrumbsItems.push(
                    {
                      text: model.name,
                      disabled: true
                    }
                  )
                })
            })
        })
    },
    openBreadcrumbsUrl (item) {
      this.$router.push({ path: item.href })
    }
  }
}
</script>

<style lang="scss">
  .v-row-group__header {
    .ma-0 {
      display: none;
    }
    .text-start {
      font-size: 18px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/spa/references/CountersModelsParameters.vue